module.exports = __webpack_public_path__ + "img/vindkraftverk (1).4f2edea1.jpg";